/* eslint-disable max-len */
/* eslint-disable guard-for-in */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import * as dayjs from 'dayjs';
import moment from 'moment';
import { rrulestr } from 'rrule';
import { RRuleOption } from './rrule.type';


@Component({
  selector: 'app-rrule',
  templateUrl: './rrule.component.html',
  styleUrls: ['./rrule.component.scss']
})
export class RruleComponent implements OnInit, OnChanges {

  @Input() option: RRuleOption = {
    rrule: '',
    frequency: 'DAILY',
    repeat: 1,
    removeUntil: false,
    date: dayjs().format('YYYY-MM-DD HH:mm:ss')// Should be sent as date and time
  };
  @Input() isDisabled?: boolean = false;
  @Output() eventChange: EventEmitter<any> = new EventEmitter();

  rruleText: string = '';
  repeatInputGroup: any = {
    'DAILY': 'Day',
    'WEEKLY': 'Week',
    'MONTHLY': 'Month',
    'YEARLY': 'Year'
  };
  //Weekly
  masterWeek: any = {
    'Sunday': {
      isSelected: false,
      value: 'SU'
    },
    'Monday': {
      isSelected: false,
      value: 'MO'
    },
    'Tuesday': {
      isSelected: false,
      value: 'TU'
    },
    'Wednesday': {
      isSelected: false,
      value: 'WE'
    },
    'Thursday': {
      isSelected: false,
      value: 'TH'
    },
    'Friday': {
      isSelected: false,
      value: 'FR'
    },
    'Saturday': {
      isSelected: false,
      value: 'SA'
    }
  };
  weekResults: string[] = [];

  //Monthly
  masterDays: any = {};
  masterWeekDays: any = {};
  currentMonthlyRule: string = 'MONTH';
  monthDayResults: string[] = [];
  monthWeekResults: string[] = [];

  //Yearly
  masterMonth: any = {
    'Jan': {
      value: 1,
      isSelected: false
    },
    'Feb': {
      value: 2,
      isSelected: false
    },
    'Mar': {
      value: 3,
      isSelected: false
    },
    'Apr': {
      value: 4,
      isSelected: false
    },
    'May': {
      value: 5,
      isSelected: false
    },
    'Jun': {
      value: 6,
      isSelected: false
    },
    'Jul': {
      value: 7,
      isSelected: false
    },
    'Aug': {
      value: 8,
      isSelected: false
    },
    'Sep': {
      value: 9,
      isSelected: false
    },
    'Oct': {
      value: 10,
      isSelected: false
    },
    'Nov': {
      value: 11,
      isSelected: false
    },
    'Dec': {
      value: 12,
      isSelected: false
    },
  };
  yearMonthResults: any[] = [];
  yearDayResults: any[] = [];


  format: string = 'YYYY-MM-DD HH:mm:ss';
  startDate: string;
  endDate: string;


  constructor() { }

  setCurrentMonthlyRule(range: string): void {
    this.currentMonthlyRule = range;
  }

  getweeks(): any[] {
    return Object.keys(this.masterWeek);
  }

  getMonths(): any[] {
    return Object.keys(this.masterMonth);
  }

  getMonthDays(): any[] {
    return Object.keys(this.masterDays);
  }

  getMonthWeek(): any[] {
    return Object.keys(this.masterWeekDays);
  }

  getParsedWeek(week): any[] {
    return Object.keys(week);
  }

  getParsedRRuleValue(rrule: string): string {
    try{
      if(this.option.removeUntil)
        rrule = rrule.replace(/UNTIL=[^;]+;?/g, '').replace(/;$/, ''); 
      return rrulestr(rrule).toText();
    }catch(err){
      return '';
    }
  }

  frequencyChange(): void {
    this.option.rrule = '';
    if(this.option?.frequency === 'WEEKLY')
    {
      this.weekResults = [];
      for(const key in this.masterWeek){
        this.masterWeek[key]['isSelected'] = false;
      }
    }
    else if(this.option?.frequency === 'MONTHLY')
    {
      this.currentMonthlyRule = 'MONTH';
      this.constructMasterDays();
      this.constructMasterWeeks();
    }
    else if(this.option?.frequency === 'YEARLY')
    {
      this.yearMonthResults = [];
      this.yearDayResults = [];
      for(const key in this.masterMonth){
        this.masterMonth[key]['isSelected'] = false;
      }
      this.constructMasterDays();
    }
    else if(this.option?.frequency === 'DAILY')
    {
      this.option.rrule = '';
    }
    this.getRRule();
  }

  selectMonthWeek(key: string, day: string): void{
    if(this.monthDayResults.length > 0){
      this.constructMasterDays();
    }
    this.monthDayResults = [];
    this.masterWeekDays[key]['weeks'][day]['isSelected'] = !this.masterWeekDays[key]['weeks'][day]['isSelected'];
    if(key === '1st'){
      if(this.masterWeekDays[key]['weeks'][day]['isSelected']){
        this.monthWeekResults.push('+1'+this.masterWeekDays[key]['weeks'][day]['value']);
      }else{
        this.monthWeekResults = this.monthWeekResults.filter((result: any) => result !== '+1'+this.masterWeekDays[key]['weeks'][day]['value']);
      }
    }else if(key === '2nd'){
      if(this.masterWeekDays[key]['weeks'][day]['isSelected']){
        this.monthWeekResults.push('+2'+this.masterWeekDays[key]['weeks'][day]['value']);
      }else{
        this.monthWeekResults = this.monthWeekResults.filter((result: any) => result !== '+2'+this.masterWeekDays[key]['weeks'][day]['value']);
      }
    }else if(key === '3rd'){
      if(this.masterWeekDays[key]['weeks'][day]['isSelected']){
        this.monthWeekResults.push('+3'+this.masterWeekDays[key]['weeks'][day]['value']);
      }else{
        this.monthWeekResults = this.monthWeekResults.filter((result: any) => result !== '+3'+this.masterWeekDays[key]['weeks'][day]['value']);
      }
    }else if(key === '4th'){
      if(this.masterWeekDays[key]['weeks'][day]['isSelected']){
        this.monthWeekResults.push('+4'+this.masterWeekDays[key]['weeks'][day]['value']);
      }else{
        this.monthWeekResults = this.monthWeekResults.filter((result: any) => result !== '+4'+this.masterWeekDays[key]['weeks'][day]['value']);
      }
    }else if(key === 'last'){
      if(this.masterWeekDays[key]['weeks'][day]['isSelected']){
        this.monthWeekResults.push('-1'+this.masterWeekDays[key]['weeks'][day]['value']);
      }else{
        this.monthWeekResults = this.monthWeekResults.filter((result: any) => result !== '-1'+this.masterWeekDays[key]['weeks'][day]['value']);
      }
    }
    this.option.rrule = '';
    this.getRRule();
  }

  selectMonthDay(key: string): void {
    if(this.monthWeekResults.length > 0){
      this.constructMasterWeeks();
    }
    this.monthWeekResults = [];
    this.masterDays[key]['isSelected'] = !this.masterDays[key]['isSelected'];
    if(this.masterDays[key]['isSelected']){
      this.monthDayResults.push(this.masterDays[key]['value']);
    }else{
      this.monthDayResults = this.monthDayResults.filter((result: any) => Number(result) !== this.masterDays[key]['value']);
    }
    this.option.rrule = '';
    this.getRRule();
  }

  selectDay(key: string): void {
    this.masterWeek[key]['isSelected'] = !this.masterWeek[key]['isSelected'];
    if(this.masterWeek[key]['isSelected']){
      this.weekResults.push(this.masterWeek[key]['value']);
    }else{
      this.weekResults = this.weekResults.filter((result: any) => result !== this.masterWeek[key]['value']);
    }
    this.option.rrule = '';
    this.getRRule();
  }

  repeatChanged(): void {
    this.option.rrule = '';
    if(this.option.repeat){
      this.getRRule();
    }
  }

  selectMonth(key: string): void {
    this.masterMonth[key]['isSelected'] = !this.masterMonth[key]['isSelected'];
    if(this.masterMonth[key]['isSelected']){
      this.yearMonthResults.push(this.masterMonth[key]['value']);
    }else{
      this.yearMonthResults = this.yearMonthResults.filter((result: any) => Number(result) !== this.masterMonth[key]['value']);
    }
    this.option.rrule = '';
    this.getRRule();
  }

  selectYearDay(key: string): void {
    this.masterDays[key]['isSelected'] = !this.masterDays[key]['isSelected'];
    if(this.masterDays[key]['isSelected']){
      this.yearDayResults.push(this.masterDays[key]['value']);
    }else{
      this.yearDayResults = this.yearDayResults.filter((result: any) => Number(result) !== this.masterDays[key]['value']);
    }
    this.option.rrule = '';
    this.getRRule();
  }

  getRRule(): void {
    if(!this.option?.rrule){
      const rruleData = {
        freq: this.option?.frequency,
        interval: this.option?.repeat
      };
      if(this.option?.date){
        rruleData['dtstart'] = this.getRRuleDateFormat(this.option?.date);
        this.startDate = rruleData['dtstart'];
        let endDate;
        if(this.option?.toDate){
          endDate = this.option?.toDate;
        }else{
          endDate = moment(this.option?.date, this.format).add(1, 'months').format(this.format);
        }
        rruleData['until'] = this.getRRuleDateFormat(endDate);
        this.endDate = rruleData['until'];
      }else if(this.startDate && this.endDate){
        rruleData['dtstart'] = this.startDate;
        rruleData['until'] = this.endDate;
      }
      if(this?.option?.frequency === 'DAILY'){
        this.option.rrule = `FREQ=DAILY;INTERVAL=${rruleData['interval']};WKST=SU;DTSTART=${rruleData?.['dtstart']};UNTIL=${rruleData?.['until']}`;
      }
      else if(this?.option?.frequency === 'WEEKLY' ){
        if(this.weekResults.length > 0){
          this.option.rrule = `FREQ=WEEKLY;INTERVAL=${rruleData['interval']};WKST=SU;BYDAY=${this.weekResults.join(',')};DTSTART=${rruleData?.['dtstart']};UNTIL=${rruleData?.['until']}`;
        }else{
          this.option.rrule = `FREQ=WEEKLY;INTERVAL=${rruleData['interval']};WKST=SU;DTSTART=${rruleData?.['dtstart']};UNTIL=${rruleData?.['until']}`;
        }
      }
      else if(this?.option?.frequency === 'MONTHLY' ){
        if(this.monthDayResults.length > 0){
          this.option.rrule = `FREQ=MONTHLY;INTERVAL=${rruleData['interval']};WKST=SU;BYMONTHDAY=${this.monthDayResults.join(',')};DTSTART=${rruleData?.['dtstart']};UNTIL=${rruleData?.['until']}`;
        }
        else if(this.monthWeekResults.length > 0){
          this.option.rrule = `FREQ=MONTHLY;INTERVAL=${rruleData['interval']};WKST=SU;BYDAY=${this.monthWeekResults.join(',')};DTSTART=${rruleData?.['dtstart']};UNTIL=${rruleData?.['until']}`;
        }
        else{
          this.option.rrule = `FREQ=MONTHLY;INTERVAL=${rruleData['interval']};WKST=SU;DTSTART=${rruleData?.['dtstart']};UNTIL=${rruleData?.['until']}`;
        }
      }
      else if(this.option?.frequency === 'YEARLY'){
          if(this.yearMonthResults.length > 0 && this.yearDayResults.length === 0){
            this.option.rrule = `FREQ=YEARLY;INTERVAL=${rruleData['interval']};BYMONTH=${this.yearMonthResults.join(',')};DTSTART=${rruleData?.['dtstart']};UNTIL=${rruleData?.['until']}`;
          }
          else if(this.yearDayResults.length > 0 && this.yearMonthResults.length === 0){
            this.option.rrule = `FREQ=YEARLY;INTERVAL=${rruleData['interval']};BYMONTHDAY=${this.yearDayResults.join(',')};DTSTART=${rruleData?.['dtstart']};UNTIL=${rruleData?.['until']}`;
          }
          else if(this.yearDayResults.length > 0 && this.yearMonthResults.length > 0) {
            this.option.rrule = `FREQ=YEARLY;INTERVAL=${rruleData['interval']};BYMONTH=${this.yearMonthResults.join(',')};BYMONTHDAY=${this.yearDayResults.join(',')};DTSTART=${rruleData?.['dtstart']};UNTIL=${rruleData?.['until']}`;
          }else{
            this.option.rrule = `FREQ=YEARLY;INTERVAL=${rruleData['interval']};WKST=SU;DTSTART=${rruleData?.['dtstart']};UNTIL=${rruleData?.['until']}`;
          }
        }
    }
    else if(this.option?.rrule){
      const rruleArray = this.option.rrule.split(';');
      rruleArray.forEach((rule: any)=>{
        const ruleData = rule.split('=');
        if(ruleData[0]==='FREQ'){
          this.option.frequency = ruleData[1];
        }else if(ruleData[0]==='INTERVAL'){
          this.option.repeat = ruleData[1];
        }else if(ruleData[0]==='DTSTART'){
          this.startDate = ruleData[1];
        }else if(ruleData[0]==='UNTIL'){
          this.endDate = ruleData[1];
        }
        if(this.option.frequency === 'WEEKLY' && ruleData[0]==='BYDAY'){
          this.weekResults = ruleData[1].split(',');
          for(const key in this.masterWeek){
            const found = this.weekResults.find((ele: any) => ele === this.masterWeek[key]['value']);
            if(found){
              this.masterWeek[key]['isSelected'] = true;
            }else{
              this.masterWeek[key]['isSelected'] = false;
            }
          }
        }
        if(this.option.frequency === 'MONTHLY' && ruleData[0] === 'BYDAY'){
          this.currentMonthlyRule = 'WEEK';
          const weekData = {
            '+1': '1st',
            '+2': '2nd',
            '+3': '3rd',
            '+4': '4th',
            '-1': 'last'
          };
          this.monthWeekResults = ruleData[1].split(',');
          for(const count in this.masterWeekDays){
            for(const key in this.masterWeekDays[count]['weeks']){
              const found = this.monthWeekResults.find((ele: any) => ((weekData[ele.slice(0,2)] === count) && (ele.slice(2,4) === this.masterWeekDays[count]['weeks'][key]['value'])));
              if(found){
                this.masterWeekDays[count]['weeks'][key]['isSelected'] = true;
              }else{
                this.masterWeekDays[count]['weeks'][key]['isSelected'] = false;
              }
            }
          }
        }
        if(this.option.frequency === 'MONTHLY' && ruleData[0] === 'BYMONTHDAY'){
          this.monthDayResults = ruleData[1].split(',');
          for(const key in this.masterDays){
            const found = this.monthDayResults.find((ele: any) => Number(ele) === this.masterDays[key]['value']);
            if(found){
              this.masterDays[key]['isSelected'] = true;
            }else{
              this.masterDays[key]['isSelected'] = false;
            }
          }
        }
        if(this.option.frequency === 'YEARLY' && ruleData[0] === 'BYMONTHDAY'){
          this.yearDayResults = ruleData[1].split(',');
          for(const key in this.masterDays){
            const found = this.yearDayResults.find((ele: any) => Number(ele) === this.masterDays[key]['value']);
            if(found){
              this.masterDays[key]['isSelected'] = true;
            }else{
              this.masterDays[key]['isSelected'] = false;
            }
          }
        }
        if(this.option.frequency === 'YEARLY' && ruleData[0] === 'BYMONTH'){
          this.yearMonthResults = ruleData[1].split(',');
          for(const key in this.masterMonth){
            const found = this.yearMonthResults.find((ele: any) => Number(ele) === this.masterMonth[key]['value']);
            if(found){
              this.masterMonth[key]['isSelected'] = true;
            }else{
              this.masterMonth[key]['isSelected'] = false;
            }
          }
        }
      });
    }
    this.rruleText = this.getParsedRRuleValue(this.option?.rrule);
    this.eventChange.emit(this.option);
  }

  getRRuleDateFormat(date: any): string {
    const year: string | number = dayjs(date, this.format).year();
    let month: string | number = dayjs(date, this.format).month() + 1;
    let day: string | number = dayjs(date, this.format).date();
    let hours: string | number = dayjs(date, this.format).hour();
    let minutes: string | number = dayjs(date, this.format).minute();
    if(month < 10) {
      month = '0'+month;
    }
    if(day < 10) {
      day = '0'+day;
    }
    if(hours < 10) {
      hours = '0'+hours;
    }
    if(minutes < 10) {
      minutes = '0'+minutes;
    }
    return String(year) + String(month) + String(day) + 'T' + String(hours) + String(minutes) + '00';
  }

  constructMasterDays(): void {
    this.masterDays = {};
    for(let i = 1; i <=31; i++){
      this.masterDays[i] = {
        isSelected: false,
        value: i
      };
      if(i === 31){
        this.masterDays['last'] = {
          isSelected: false,
          value: -1
        };
      }
    }
  }

  constructMasterWeeks(): void {
    for(const key in this.masterWeek){
        this.masterWeek[key]['isSelected'] = false;
    }
    this.masterWeekDays = {
      '1st': {
        weeks: JSON.parse(JSON.stringify(this.masterWeek))
      },
      '2nd': {
        weeks: JSON.parse(JSON.stringify(this.masterWeek))
      },
      '3rd': {
        weeks: JSON.parse(JSON.stringify(this.masterWeek))
      },
      '4th': {
        weeks: JSON.parse(JSON.stringify(this.masterWeek))
      },
      'last': {
        weeks: JSON.parse(JSON.stringify(this.masterWeek))
      }
    };

  }

  ngOnInit(): void {
    this.constructMasterDays();
    this.constructMasterWeeks();
    this.getRRule();
  }

  ngOnChanges(changes: SimpleChanges): void{
    if('option' in changes){
      this.getRRule();
    }
  }

}
